module.exports = __webpack_public_path__ + "static/media/return-arrow-daniparts.f043bb38.svg";